import { jsx as _jsx } from "react/jsx-runtime";
import { Portal } from '@integration-app/react';
import clsx from 'clsx';
import classes from './styles.module.css';
import { useSchemaBuilderRowContext } from '../row-context';
export function PropertiesPortal() {
    const { setPropertiesRef } = useSchemaBuilderRowContext();
    return _jsx("div", { className: clsx(classes.propertyList), ref: setPropertiesRef });
}
export function Properties({ children }) {
    const { propertiesRef } = useSchemaBuilderRowContext();
    return _jsx(Portal, { node: propertiesRef, children: children });
}
function PropertyRoot({ children, className, ...props }) {
    return (_jsx("span", { className: classes.propertyWrapper, children: _jsx("span", { className: clsx(classes.property, className), ...props, children: children }) }));
}
function PropertyName({ children, className, ...props }) {
    return (_jsx("span", { className: clsx(classes.propertyName, className), ...props, children: children }));
}
function PropertyValue({ children, className, ...props }) {
    return (_jsx("span", { className: clsx(classes.propertyValue, className), ...props, children: children }));
}
export const Property = Object.assign(PropertyRoot, {
    Name: PropertyName,
    Value: PropertyValue,
});
export function PropertiesInModal({ children }) {
    return _jsx("div", { className: classes.propertiesInModal, children: children });
}
//# sourceMappingURL=Properties.js.map